import React from 'react';
import { AnnouncementBanner } from '../components/AnnouncementBanner';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { ComparisonTable } from '../components/ComparisonTable';
import { AIWorkflowDemo } from '../components/AIWorkflowDemo';
import { CaseStudies } from '../components/CaseStudies';
import { PricingSection } from '../components/PricingSection';
import { RiskReversal } from '../components/RiskReversal';
import { SupportSection } from '../components/SupportSection';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { RequirementsNotice } from '../components/RequirementsNotice';
import { FloatingCTA } from '../components/FloatingCTA';
export function SalesFunnel() {
  return <div className="w-full min-h-screen bg-white" data-id="element-282">
      <AnnouncementBanner data-id="element-283" />
      <Hero data-id="element-284" />
      <ProblemSection data-id="element-285" />
      <FeaturesSection data-id="element-286" />
      <ComparisonTable data-id="element-287" />
      <AIWorkflowDemo data-id="element-288" />
      <CaseStudies data-id="element-289" />
      <PricingSection data-id="element-290" />
      <RiskReversal data-id="element-291" />
      <SupportSection data-id="element-292" />
      <HowItWorks data-id="element-293" />
      <FAQ data-id="element-294" />
      <RequirementsNotice data-id="element-295" />
      <FloatingCTA data-id="element-296" />

      {/* Footer */}
      <footer className="bg-[var(--jet-black)] text-white py-8 px-6" data-id="element-297">
        <div className="max-w-6xl mx-auto text-center" data-id="element-298">
          <p className="text-2xl font-bold text-[var(--viridia-green)] mb-2" data-id="element-299">
            Viridia Analytics
          </p>
          <p className="text-gray-400 text-sm" data-id="element-300">
            Automated customer acquisition for service businesses
          </p>
          <p className="text-gray-500 text-xs mt-4" data-id="element-301">
            © 2024 Viridia Analytics. All rights reserved.
          </p>

          {/* Legal Disclaimer */}
          <div className="mt-6 pt-6 border-t border-gray-800" data-id="element-302">
            <p className="text-gray-500 text-xs leading-relaxed max-w-4xl mx-auto" data-id="element-303">
              <strong data-id="element-304">Disclaimer:</strong> Results may vary. While we strive to
              provide excellent service and automation tools, Viridia Analytics
              makes no guarantees regarding specific outcomes, revenue
              increases, or business results. Past performance and case studies
              are not indicative of future results. Viridia Analytics shall not
              be held liable for any direct, indirect, incidental,
              consequential, or special damages, including but not limited to
              loss of revenue, loss of profits, business interruption, or any
              other commercial damages or losses arising from the use of our
              services, whether caused by negligence, breach of contract, acts
              of God, or any other cause beyond our reasonable control. By using
              our services, you acknowledge and agree to these terms.
            </p>
          </div>
        </div>
      </footer>
    </div>;
}